// extracted by mini-css-extract-plugin
export default {"item":"user-search-bar_item__fdy88","add-button":"user-search-bar_add-button__aBQ33","add-button__icon":"user-search-bar_add-button__icon__9v1z7"};